/**
 * Печать этикеток с кодами маркировки.
 *
 * Печатаем не саму страницу, а отдельный документ в скрытом фрейме. Так вёрстка
 * этикетки не зависит от стилей приложения (у модалки классы CSS-модулей —
 * хешированные, целиться в них из печатных правил ненадёжно), и ничего не нужно
 * прятать через @media print. Заодно это работает одинаково во вкладке браузера
 * и в установленном приложении.
 */

/** Экранирование текста, попадающего в разметку печатного документа. */
function escapeHtml(text) {
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

const PRINT_STYLES = `
  @page { margin: 10mm; }
  body {
    margin: 0;
    font-family: Arial, "Helvetica Neue", sans-serif;
    color: #000;
    background: #fff;
  }
  h1 {
    margin: 0 0 6mm;
    font-size: 12pt;
    text-align: center;
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 5mm;
  }
  .label {
    border: 1px solid #000;
    padding: 3mm;
    text-align: center;
    /* Этикетка не должна разрываться между страницами. */
    break-inside: avoid;
    page-break-inside: avoid;
  }
  .label svg {
    width: 34mm;
    height: 34mm;
    display: block;
    margin: 0 auto 2mm;
  }
  .code {
    font-family: "Courier New", monospace;
    font-size: 7pt;
    word-break: break-all;
    line-height: 1.25;
  }
`;

/**
 * @param {string} title      название товара — печатается заголовком
 * @param {Array<{code: string, svg: string}>} labels
 */
export function printLabels(title, labels) {
  if (!labels.length) return;

  const html = `<!doctype html>
<html lang="ru">
<head><meta charset="utf-8"><title>${escapeHtml(title)}</title><style>${PRINT_STYLES}</style></head>
<body>
  <h1>${escapeHtml(title)}</h1>
  <div class="grid">
    ${labels
      .map((l) => `<div class="label">${l.svg}<div class="code">${escapeHtml(l.code)}</div></div>`)
      .join('')}
  </div>
</body>
</html>`;

  const frame = document.createElement('iframe');
  frame.setAttribute('aria-hidden', 'true');
  frame.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;';
  document.body.appendChild(frame);

  const cleanup = () => frame.remove();

  frame.onload = () => {
    try {
      frame.contentWindow.focus();
      frame.contentWindow.print();
    } finally {
      // Диалог печати блокирует поток, но в части браузеров — нет,
      // поэтому убираем фрейм с запасом по времени.
      setTimeout(cleanup, 1000);
    }
  };

  const doc = frame.contentDocument;
  doc.open();
  doc.write(html);
  doc.close();
}
